import React from "react";
import  { useState, useEffect } from 'react';
import './classes/HockeyAgency.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";

const HockeyAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [hockeyDirectors, setHockeyDirectors] = useState([]);
   const [agencyNews, setAgencyNews] = useState([]);

    useEffect(() => {

         const hockeyDirectors = [             
            {
                name: "Michael Collier",
                image: "/basic/web/images/agent/picture-700302-1727200864.png",
                link: "/agent/michael-collier",
                bio: ["SMWW Hockey Agency Director","PHPA , DEL, and PWHL Player Agent"]
            },
            {
                name: "Daniel Nyegaard",
                image: "/basic/web/images/agent/picture-805913-1731711555.jpg",
                link: "/agent/daniel-nyegaard",
                bio: ["​SMWW European Hockey Agency Director","Former GM of the Herning Blue Fox"]
            },
            {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/dr.-lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            },
        ];
        setHockeyDirectors(hockeyDirectors);
        const agencyNews = [
  {
    img: "/basic/web/images/agent/SMWW_Agency-Kenya_Fari_Agent_Advisor.png",
    title: "SMWW Agent Advisor Kenya Fari Earns FIBA Certification",
    link: "/content/smww-agent-advisor-kenya-fari-earns-fiba-certification"
  },
  {
    img: "/basic/web/images/agent/Michael_Collier_SMWW_Hockey_Agency_Director.png",
    title: "SMWW Hockey Agency Director Michael Collier Earns PWHLP...",
    link: "/content/smww-hockey-agency-director-michael-collier-earns-pwhlpa-player-agent-certification"
  },
  {
    img: "/basic/web/images/agent/Luquay_Washington.png",
    title: "SMWW Agency Welcomes New Athlete: Luquay Washington",
    link: "/content/smww-agency-welcomes-new-athlete-luquay-washington"
  },
  {
    img: "/basic/web/images/agent/SMWW_Agency_Vincent_Demps.png",
    title: "Meet SMWW Agent Advisor J. Vincent Demps: From Military...",
    link: "/content/meet-smww-agent-advisor-j-vincent-demps-military-service-mastering-sports-representation"
  },
  {
    img: "/basic/web/images/agent/SMWW_Hockey_Agency.png",
    title: "SMWW Hockey Agency Director Michael Collier Secures Eur...",
    link: "/content/smww-hockey-agency-director-michael-collier-secures-european-pro-deal-aimee-o’neil-hammarby"
  }
];
setAgencyNews(agencyNews);
        
    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="hockey-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/hockey_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_hockey.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "25.5%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.8vw",
                fontWeight: "bold"
                }}
            >
                SMWW Hockey Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "2.24vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                 representing hockey players throughout <br />
                 the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="hockey-agency-main">
                <Helmet><title>SMWW Hockey Agency</title></Helmet>
                <div className="left hockey-agency-left">
                    <div className="view-content">
                    <h2>Hockey Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {hockeyDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === hockeyDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {hockeyDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 ? "mob_sports_wrapper_odd" : "mob_sports_wrapper_even"}
                            style={{ float: index % 2 === 0 ? "left" : "right", width: "49%" }}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === hockeyDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="hockey-agency-center">
                        <h1>SMWW Hockey Agency</h1>
                        <p><img  class="imgfulli lazyloaded"  src="/basic/web/images/agent/hockey_0.jpg" style={{"float":"right"}}/>As an industry leader, SMWW Hockey agency has developed strong relationships with NHL owners, general managers, coaches, and scouts, at hockey clubs in North America and Europe. In doing so, we are best positioned to maximize our hockey athletes' contract dollars, endorsement offers, and the athletic training our hockey clients need. At SMWW Hockey, we provide comprehensive sports management services for professional hockey players, whether they are drafted rookies or established veterans.</p>                    
                        <p>SMWW Hockey has Agent Advisors all over the world to mentor and assist future and current professional hockey players. SMWW Hockey is prepared to provide a level of service and attention that can't be matched by any super agency. We guide our clients through the experiences of a professional athlete. A professional hockey career is a "once in a lifetime" opportunity that a selected few are fortunate to experience. It is that opportunity that SMWW wants to enhance and promote to the highest level possible.</p>
                        <p>Hockey players all have very distinctive needs. Whether Major Junior, College, International or Professional, SMWW Hockey Agent Advisors are versatile in adapting to their clients. When evaluating who an athlete should pick to represent them, there are many choices. Sports Management Worldwide will help you evaluate what you should look for in a hockey agent and what is most important for your hockey career. From contract negotiation to product endorsements, from travel arrangements to work out camps, on the ice or off the ice, Sports Management Worldwide wants to be a step ahead of you, assisting you.</p>
                        <p>Your professional hockey career is making the most of your athletic savvy on the ice, while SMWW Hockey's job is making the most of their business savvy off the ice!</p>
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                If you are a hockey player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/hockey"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR HOCKEY AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                   <AgencySidebar/>
                   <h2>SMWW Sports Agency News</h2>
                   <div className="agency_blog">
      <ul className="list-unstyled mb-0">

        {agencyNews.map((post, index) => (
          <div key={index}>
            <li
              style={{
                listStyleType: "none",
                listStyle: "outside none"
              }}
            >
              <a href={post.link}>
                <img src={post.img} alt={post.title} />
              </a>

              <p className="stwwt-post-title">
                <a className="post-para" href={post.link}>
                  {post.title}
                </a>
                <br />
                <a href={post.link}>
                  <span className="button mr-1 arrow">Read Article</span>
                </a>
              </p>
            </li>

            {/* Separator */}
            {index < agencyNews.length - 1 && <li className="sepline">&nbsp;</li>}
          </div>
        ))}

      </ul>
    </div>

                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default HockeyAgency;